<p-tabs value="nyc-sync" [value]="initialSegment()">
  <p-tablist>
    <p-tab value="nyc-sync" [routerLink]="['nyc-sync']">NYC Sync</p-tab>
    <p-tab value="users" [routerLink]="['users']">Users</p-tab>
  </p-tablist>
</p-tabs>
<router-outlet/>
